module.exports = __webpack_public_path__ + "img/布尔运算.242367e6.svg";